import React, { Component } from "react";
import ModalContainer from "../../../../../modules/commons/ModalContainer";
import SimpleModal from "../../../../../modules/popup/SimpleModal";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import { JenisCetakanOptions, PelunasanStatusOptions } from "../config";
import FlexView from "react-flexview";
import SimpleDate from "../../../../../modules/SimpleDate";
import { fetchDataAsync } from "../../../../../Services/Utils";
import Api from "../../../../../Services/Api";
import { HttpStatus } from "../../../../common/Constants";
import { mapToObjectDDL, removeNullFields } from "../../../../common/mapper";
import SimpleLoadingOverlay from "../../../../../modules/popup/SimpleLoadingOverlay";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleInput from "../../../../../modules/SimpleInput";
import moment from "moment";
import { saveAs } from "file-saver";

class PrintFilterModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: {
        type: null,
        status: null,
        leasing: null,
        startDateFakturJual: null,
        endDateFakturJual: null,
        noBbm: null,
        kodeCabang: this.props.kodeCabang?.value,
      },
      leasingOptions: [],
      loading: false,
      error: null,
      dataBBMOptions: []
    };
  }

  componentDidMount() {
    this.fetchDataLeasing();
  }

  componentDidUpdate(prevProps, prevState) {
    const newJenis = this.state.formData.type?.value;
    const prevJenis = prevState.formData.type?.value;
    if (prevJenis !== newJenis && newJenis === "LAPORAN_ALOKASI_BBM") {
      this.fetchDataBBM();
    }
  }

  handleLoading = () => {
    this.setState((prev) => ({ ...prev, loading: !prev.loading }));
  };

  fetchDataLeasing = async () => {
    this.handleLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllMasterLeasing,
      setError: this.props.setError,
      menuName: "Faktur Jual - Sales Order",
      args: {
        paramFilters: {
          listKodeCabang: [this.props.kodeCabang?.value],
        },
      },
    });
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState((prev) => ({
        ...prev,
        leasingOptions: res.data.data.map((item) =>
          mapToObjectDDL(item.leasingName, item.leasingId)
        ),
      }));
    }
    this.handleLoading();
  };

  fetchDataBBM = async () => {
    this.handleLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").getBBMForPaymentLeasing,
      menuName: "BBM Data",
      setError: this.props.setError,
      args: {
        kodeCabang: this.props.kodeCabang?.value,
        specialCategory: ""
      },
    });
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState((prevState) => ({
        ...prevState,
        dataBBMOptions: res.data.data?.map(item => mapToObjectDDL(item.nomorBBM, item.nomorBBM)),
      }));
    }
    this.handleLoading();
  };

  handleFormChange = async (name, value) => {
    const newJenis = value?.value;

    this.setState((prev) => {
      let updatedForm = {
        ...prev.formData,
        [name]: value,
      };

      if (name === "type") {
        const prevJenis = prev.formData.type?.value;

        if (
          prevJenis === "LAPORAN_ALOKASI_BBN" &&
          newJenis !== "LAPORAN_ALOKASI_BBN"
        ) {
          updatedForm = {
            ...updatedForm,
            noBbm: null,
          };
        } else if (
          prevJenis === "LAPORAN_SUDAH_PENAGIHAN" &&
          newJenis !== "LAPORAN_SUDAH_PENAGIHAN"
        ) {
          updatedForm = {
            ...updatedForm,
            status: null,
            leasing: null,
            startDateFakturJual: null,
            endDateFakturJual: null,
          };
        }
      }

      return {
        ...prev,
        formData: updatedForm,
      };
    });
  };

  renderAdditionalForm = () => {
    const { formData, leasingOptions, error, dataBBMOptions } = this.state;
    if (formData.type?.value === "LAPORAN_SUDAH_PENAGIHAN") {
      return (
        <FlexView column style={{ gap: "10px" }}>
          <SimpleDDL
            id="select_options_status"
            box="search"
            name="status"
            label="Status"
            mandatory
            errorMessage={error?.status}
            options={PelunasanStatusOptions}
            value={formData.status}
            onChange={(value, { name }) => this.handleFormChange(name, value)}
          />
          <SimpleDDL
            id="select_options_leasing"
            box="search"
            name="leasing"
            label="Leasing"
            mandatory
            errorMessage={error?.leasing}
            options={leasingOptions}
            value={formData.leasing}
            onChange={(value, { name }) => this.handleFormChange(name, value)}
          />
          <FlexView column style={{ gap: "10px" }} vAlignContent="center">
            <div className="txt-site txt-11 txt-main txt-bold">
              <h4>
                Periode Faktur Jual <span style={{ color: "red" }}>*</span>
              </h4>
            </div>
            <FlexView style={{ gap: "10px" }} vAlignContent="center">
              <SimpleDate
                mandatory
                id="select_start_date"
                name="startDateFakturJual"
                className="width width-550px"
                nextdate
                errorMessage={error?.startDate}
                date={formData?.startDateFakturJual}
                onChange={(value) =>
                  this.handleFormChange(
                    "startDateFakturJual",
                    moment(value).format("DD-MM-YYYY")
                  )
                }
              />
              <p className="margin margin-bottom-15px">TO</p>
              <SimpleDate
                mandatory
                id="select_emd_date"
                name="endDateFakturJual"
                nextdate
                errorMessage={error?.endDate}
                date={formData?.endDateFakturJual}
                minDate={formData?.startDateFakturJual}
                onChange={(value) =>
                  this.handleFormChange(
                    "endDateFakturJual",
                    moment(value).format("DD-MM-YYYY")
                  )
                }
              />
            </FlexView>
          </FlexView>
        </FlexView>
      );
    }

    if (formData.type?.value === "LAPORAN_ALOKASI_BBM") {
      return (
        <SimpleDDL
          id="select_nomor_bbm"
          name="noBbm"
          box="search"
          label="Nomor BBM"
          mandatory
          options={dataBBMOptions}
          errorMessage={error?.noBbm}
          value={formData.noBbm}
          onChange={(value, { name }) => this.handleFormChange(name, value)}
        />
      );
    }
    return null;
  };

  validate = () => {
    const { formData } = this.state;
    let error = {};

    if (!formData.type) {
      error.type = "Jenis Cetakan wajib dipilih.";
    }

    if (formData.type?.value === "LAPORAN_SUDAH_PENAGIHAN") {
      if (!formData.status) {
        error.status = "Status wajib dipilih.";
      }
      if (!formData.leasing) {
        error.leasing = "Leasing wajib dipilih.";
      }
      console.log(formData)
      if (!formData.startDateFakturJual) {
        error.startDate = "Tanggal mulai wajib diisi.";
      }
      if (!formData.endDateFakturJual) {
        error.endDate = "Tanggal akhir wajib diisi.";
      }
    }

    if (formData.type?.value === "LAPORAN_ALOKASI_BBM") {
      if (!formData.noBbm) {
        error.noBbm = "Nomor BBM wajib diisi.";
      }
    }

    this.setState({ error });

    return Object.keys(error).length === 0;
  };

  handleCetak = async () => {
    const isValid = this.validate();
    const { formData } = this.state;

    const payload = {
      ...formData,
      type: formData.type?.value,
      startDateFakturJual: formData?.startDateFakturJual,
      endDateFakturJual: formData?.endDateFakturJual,
      status: formData?.status?.value,
      leasingId: formData?.leasing?.value,
      noBbm: formData.noBbm?.value
    }
    const {leasing, ...rest} = payload

    if (isValid) {
      this.handleLoading()
      const res = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_TRANSACTION_FILE").cetakExcelPenagihanLeasing,
        menuName: "Cetak Penagihan Leasing",
        setError: this.props.setError,
        args: removeNullFields(rest),
      });
      if(res.ok){
        const blob = new Blob([res.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
        saveAs(blob, `${formData.type?.label}.xlsx`)
      }
      this.handleLoading()
    }
  };

  render() {
    const { filterVisible, onClickClose } = this.props;
    const { formData, error } = this.state;
    return (
      <>
        <SimpleModal
          title="Cetakan"
          styles={{ width: "50%" }}
          visible={filterVisible}
          onClickClose={onClickClose}
          content={
            <ModalContainer>
              <FlexView column style={{ gap: "10px" }}>
                <SimpleDDL
                  id="select_options_jenis_cetakan"
                  box="search"
                  name="type"
                  label="Jenis Cetakan"
                  mandatory
                  options={JenisCetakanOptions}
                  value={formData.type}
                  errorMessage={error?.type}
                  onChange={(value, { name }) =>
                    this.handleFormChange(name, value)
                  }
                />
                {this.renderAdditionalForm()}
                <FlexView hAlignContent="right">
                  <SimpleButton
                    type="button"
                    text="Cetak"
                    onClick={this.handleCetak}
                  />
                </FlexView>
              </FlexView>
            </ModalContainer>
          }
        />
        {this.state.loading && (
          <SimpleLoadingOverlay active={this.state.loading} />
        )}
      </>
    );
  }
}

export default PrintFilterModal;
